export const AD_FREE_STORAGE_KEY = "ddanzitAdFreeMode";
export const AD_FREE_COOKIE_KEY = "ddanzit_ad_free_mode";

const enabledValue = "true";

export function isAdFreeModeEnabled(): boolean {
    const localStorageEnabled = window.localStorage.getItem(AD_FREE_STORAGE_KEY) === enabledValue;
    const cookieEnabled = document.cookie
        .split(";")
        .map((cookie) => cookie.trim())
        .some((cookie) => cookie === `${AD_FREE_COOKIE_KEY}=${enabledValue}`);

    return localStorageEnabled || cookieEnabled;
}

export function enableAdFreeMode() {
    window.localStorage.setItem(AD_FREE_STORAGE_KEY, enabledValue);
    document.cookie = `${AD_FREE_COOKIE_KEY}=${enabledValue}; path=/; max-age=315360000; SameSite=Lax`;
}
